module.exports = __webpack_public_path__ + "static/media/ecrire-message-cercle.0e275564.png";